import React, { useEffect } from 'react'

interface TemporaryMessageProps {
  message: string | null
  type: 'error' | 'success' | 'info'
  onClear?: () => void
  duration?: number
}

export const TemporaryMessage: React.FC<TemporaryMessageProps> = ({ 
  message, 
  type, 
  onClear, 
  duration = 5000 
}) => {
  useEffect(() => {
    if (message && onClear) {
      const timer = setTimeout(() => {
        onClear()
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [message, onClear, duration])

  if (!message) return null

  const getMessageStyle = () => {
    switch (type) {
      case 'error':
        return {
          background: '#f8d7da',
          color: '#721c24',
          border: '1px solid #f5c6cb'
        }
      case 'success':
        return {
          background: '#d4edda',
          color: '#155724',
          border: '1px solid #c3e6cb'
        }
      case 'info':
        return {
          background: '#d1ecf1',
          color: '#0c5460',
          border: '1px solid #bee5eb'
        }
      default:
        return {}
    }
  }

  return (
    <div 
      style={{
        ...getMessageStyle(),
        padding: '8px 12px',
        borderRadius: '6px',
        fontSize: '12px',
        marginTop: '8px',
        position: 'relative'
      }}
    >
      {message}
      {onClear && (
        <button
          onClick={onClear}
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '14px',
            padding: '0',
            lineHeight: '1'
          }}
        >
          ×
        </button>
      )}
    </div>
  )
}
